export const CHANGE_THEME_CONFIG = 'CHANGE_THEME_CONFIG';